import { MARKER_START2} from './MarkerStartTypes2'

const initialState = {
    markerStart2: ""
}

const markerStartReducer2 = (state = initialState, action) => {
    
    switch (action.type) {
        case MARKER_START2:
            
            return {
                markerStart2: action.load
            }
    
        default:
          return state
    }

}


export default markerStartReducer2;